import React, { useEffect, useState, useRef } from 'react';
import {DropdownContainer, DropdownToggler,DropdownMenu, DropdownMenuList, DropdownMenuItem} from './styles'
import {MenuSvg} from '../../theme/icons/Menu'

const Dropdown = ({ options, placeholder = 'MENU', onChange }) => {
    const node = useRef(null);
    const [open, setOpen] = useState(false);

    const handleChange = (opt) => {
        onChange(opt.title);
        setOpen(false);
    };

    useEffect(() => {
        const handleClick = (e) => {
            e.stopPropagation();
            const target = e.target;
            if (node.current && !node.current.contains(target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    return (
        <DropdownContainer ref={node}  tabindex="0">
            <DropdownToggler onClick={() => setOpen(!open)} className={open ? 'active': ''}>
                <MenuSvg /> <span>MENU</span>
            </DropdownToggler>

            {open && (
                <DropdownMenu className={open ? 'active': ''}>
                    <DropdownMenuList>
                        {options.map((opt, index) => (
                            <DropdownMenuItem onClick={() => handleChange(opt)} key={index}>
                                {opt.title}
                            </DropdownMenuItem>
                        ))}
                    </DropdownMenuList>
                </DropdownMenu>
            )}
        </DropdownContainer>
    );
};

export default Dropdown;
